import { IconButton } from 'assets/icons';
import ImageIcon from 'components/Icon/ImageIcon';
import { ButtonHTMLAttributes } from 'react';
import styled from 'styled-components';
import { device } from 'styles/breakpoints';
import { theme } from 'styles/theme';

export interface IButton extends ButtonHTMLAttributes<HTMLButtonElement> {}

export interface IButtonWithWrapper extends IButton {
  error?: boolean | string;
}

export const ButtonWithoutWrapper = ({ children, onClick, ...props }: IButton): JSX.Element => {
  return (
    <ButtonWrapper role="button" onClick={onClick} {...props}>
      {children}
      <ImageIcon src={IconButton} alt="Button icon" />
    </ButtonWrapper>
  );
};

const Button = ({ error, ...props }: IButtonWithWrapper): JSX.Element => {
  return (
    <Wrapper>
      <ButtonWithoutWrapper {...props} />
      <SectionError $visible={!!error}>{error}</SectionError>
    </Wrapper>
  );
};

export default Button;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
`;

const ButtonWrapper = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;

  width: 100%;
  height: 62px;
  max-width: 465px;
  margin: 0 auto;
  gap: 10px;

  background-color: ${theme.colors.primary};
  border-radius: 20px;

  color: #fff;
  font-size: 1rem;
  font-weight: 700;

  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
  border: none;
  appearance: none;

  transition: background-color 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      background-color: ${theme.colors.remondis_accent};
    }
  }

  &:active {
    background-color: ${theme.colors.remondis_accent};
  }

  &:focus,
  &:focus-visible {
    outline: none;
  }

  &:disabled {
    cursor: auto;
    background-color: ${theme.colors.grayscale};
  }
`;

const SectionError = styled.p<{ $visible: boolean }>`
  color: ${theme.colors.remondis_accent};
  font-weight: 700;
  font-size: 1rem;
  text-align: center;
  letter-spacing: -0.02px;
  margin: 0;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  width: 100%;
  padding-top: 8px;
  transition: opacity 0.3s ease-out;

  @media ${device.sm} {
    white-space: pre-wrap;
  }
`;
